<div class="hi-pin">
  <div class="content">
    <p class="title">
      {{data.title}}
    </p>
    <div class="form">
      <mat-form-field appearance="outline" floatLabel="never">
        <input matInput placeholder="Card Pin" [formControl]="cardPinInput">
      </mat-form-field>
      <div class="submit-button">
        <button (click)="submitForm()">{{'createOrderPage.buyText' | translate}}</button>
      </div>
    </div>
  </div>
</div>
